/* ==========================================================================
   About page motion — ported from the Claude Design "About Us" prototype.
   Reveals on intersect, count-up stats, and a clip-path wipe on the CTA.
   The design's own header behaviour is omitted: the storefront already has
   a sticky frosted header, and running a second scroll handler over it would
   fight the theme.
   ========================================================================== */
(() => {
  const root = document.querySelector('[data-ab]');
  if (!root) return;
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  const nodes = () => Array.from(root.querySelectorAll('[data-anim]'));

  const countUp = (el) => {
    const target = parseInt(el.dataset.count, 10);
    if (Number.isNaN(target)) return;
    const t0 = performance.now();
    const tick = (t) => {
      const p = Math.min(1, (t - t0) / 900);
      const eased = 1 - Math.pow(1 - p, 3);
      el.textContent = String(Math.round(eased * target));
      if (p < 1) requestAnimationFrame(tick);
    };
    requestAnimationFrame(tick);
  };

  const reveal = (el) => {
    if (el.dataset.shown) return;
    el.dataset.shown = '1';
    window.setTimeout(() => {
      el.style.opacity = '1';
      el.style.transform = 'none';
      if (el.dataset.wipe !== undefined) el.style.clipPath = 'inset(0 0 0 0)';
      if (el.dataset.count) countUp(el);
    }, parseInt(el.dataset.delay || '0', 10));
  };

  // Prime the hidden state.
  for (const el of nodes()) {
    if (el.dataset.shown) continue;
    el.style.opacity = '0';
    const h = el.dataset.hide;
    if (h && h !== 'none') el.style.transform = h;
    if (el.dataset.wipe !== undefined) el.style.clipPath = 'inset(0 100% 0 0)';
  }

  const io = new IntersectionObserver(
    (entries) => {
      for (const entry of entries) {
        if (!entry.isIntersecting) continue;
        io.unobserve(entry.target);
        reveal(entry.target);
      }
    },
    { threshold: 0.2 }
  );

  requestAnimationFrame(() => {
    for (const el of nodes()) if (!el.dataset.shown) io.observe(el);
  });

  /* Safety net from the prototype: anything already inside the viewport that
     the observer missed (short sections, restored scroll position) still
     reveals rather than sitting invisible. */
  const net = window.setInterval(() => {
    const pending = nodes().filter((el) => !el.dataset.shown);
    if (!pending.length) {
      window.clearInterval(net);
      return;
    }
    for (const el of pending) {
      const r = el.getBoundingClientRect();
      if (r.top < window.innerHeight * 0.9 && r.bottom > 0) reveal(el);
    }
  }, 800);
})();
